import React from 'react';
import { IMainCard } from '../../../Interfaces/componentTypes';
import styles from './mainCard.module.scss';

interface IProps {
  content:IMainCard,
  index:number
}


const MainCard:React.FC<IProps> = ({content:{image,title},index}) => {
  const dynamicStyles = {
    borderTopLeftRadius: index === 0 ? "50px" : undefined,
    borderBottomRightRadius: index === 3 ? "50px" : undefined,
  };

  return (
    <div
     className={styles.container}
     style={dynamicStyles}
     >
      <div className={styles.titleBox}>
        <p className={styles.title} style={{paddingLeft:index === 0 ? "10px" : undefined}}>
            {title}
        </p>
      </div>
      <div className={styles.imageBox}>
      <img src={image} className={styles.image} alt={`${image}`} />
      </div>
    </div>
  )
}

export default MainCard
